import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import { selectCockpitSwitchingOnOffering } from '../selectors'

/** As long as the refreshed tiles' ring runs (`TileShell`'s `tileRefreshed`). */
const HIGHLIGHT_MS = 2400

/** `true` for a moment once a programme has been switched on and its data has come back, so the
 *  tiles that data fills can say they were refreshed. */
export const useCockpitSwitchedOnHighlight = () => {
  const switchingOnOffering = useSelector(selectCockpitSwitchingOnOffering)
  const wasSwitchingRef = useRef(false)
  const [isHighlighted, setIsHighlighted] = useState(false)

  useEffect(() => {
    if (switchingOnOffering) {
      wasSwitchingRef.current = true
      setIsHighlighted(false)
      return
    }

    if (!wasSwitchingRef.current) {
      return
    }

    wasSwitchingRef.current = false
    setIsHighlighted(true)

    const timeout = window.setTimeout(() => setIsHighlighted(false), HIGHLIGHT_MS)

    return () => window.clearTimeout(timeout)
  }, [switchingOnOffering])

  return isHighlighted
}
